import { UserSelectionWidget } from "components/FormWidget";

const uiSchema = () => ({
  manager_id: {
    "ui:widget": UserSelectionWidget,
  },
  location: {
    "ui:field": "location",
  },
});

export default uiSchema;
